import { Spinner } from '@wartek-id/spinner'

import PanelProfil from 'app/KinerjaKepalaSKBPage/components/PanelProfil'
import useSchoolContext from 'app/KinerjaKSPage/hooks/useSchoolContext'

export default function KonfirmasiProfil() {
  const { profile, isProfileFetched, isLoadingProfile } = useSchoolContext()

  if (isLoadingProfile) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Spinner data-testid="loading-spinner" />
      </div>
    )
  }

  if (isProfileFetched) {
    return <PanelProfil profile={profile} />
  }

  return null
}
